export default __webpack_public_path__ + "static/media/collage.eebda4c1.png";